import { useRoute, useRouter } from 'vue-router'
import equal from 'fast-deep-equal'
import { toQuery } from './fns'

export const useUrlQueryUpdater = () => {
  const router = useRouter()
  const route = useRoute()

  return async data => {
    const { name, params } = route
    const query = toQuery(data)
    if (equal(route.query, query)) {
      return // Avoid changing route when no change
    }
    const to = { name, params, query }
    await router.replace(to)
  }
}
